(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[890],{

/***/ 8949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ List; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-safe-context/create-safe-context.js
var create_safe_context = __webpack_require__(68216);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/List.context.js


const [ListProvider, useListContext] = (0,create_safe_context/* createSafeContext */.R)("List component was not found in tree");


//# sourceMappingURL=List.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/ListItem/ListItem.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { spacing, center }, getRef) => ({
  itemWrapper: {
    ref: getRef("itemWrapper"),
    display: "inline-flex",
    flexDirection: "column",
    whiteSpace: "normal"
  },
  item: {
    whiteSpace: "nowrap",
    lineHeight: center ? 1 : theme.lineHeight,
    "&:not(:first-of-type)": {
      marginTop: theme.fn.size({ size: spacing, sizes: theme.spacing })
    }
  },
  withIcon: {
    listStyle: "none",
    [`& .${getRef("itemWrapper")}`]: {
      display: "inline-flex",
      alignItems: center ? "center" : "flex-start",
      flexDirection: "row"
    }
  },
  itemIcon: {
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: theme.spacing.sm
  }
}));

/* harmony default export */ var ListItem_styles = (useStyles);
//# sourceMappingURL=ListItem.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/ListItem/ListItem.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {};
const ListItem = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("ListItem", defaultProps, props), { className, children, icon } = _a, others = __objRest(_a, ["className", "children", "icon"]);
  const {
    icon: ctxIcon,
    spacing,
    center,
    listStyleType,
    size,
    withPadding,
    classNames,
    styles,
    unstyled
  } = useListContext();
  const _icon = icon || ctxIcon;
  const { classes, cx } = ListItem_styles({ withPadding, size, listStyleType, center, spacing }, { classNames, styles, unstyled, name: "List" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    component: "li",
    className: cx(classes.item, { [classes.withIcon]: _icon }, className),
    ref
  }, others), /* @__PURE__ */ react.createElement("div", {
    className: classes.itemWrapper
  }, _icon && /* @__PURE__ */ react.createElement("span", {
    className: classes.itemIcon
  }, _icon), /* @__PURE__ */ react.createElement("span", null, children)));
});
ListItem.displayName = "@mantine/core/ListItem";


//# sourceMappingURL=ListItem.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/List.styles.js


var List_styles_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var List_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var List_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var List_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var List_styles_defNormalProp = (obj, key, value) => key in obj ? List_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var List_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (List_styles_hasOwnProp.call(b, prop))
      List_styles_defNormalProp(a, prop, b[prop]);
  if (List_styles_getOwnPropSymbols)
    for (var prop of List_styles_getOwnPropSymbols(b)) {
      if (List_styles_propIsEnum.call(b, prop))
        List_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var List_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { withPadding, size, listStyleType }) => ({
  root: __spreadProps(List_styles_spreadValues({}, theme.fn.fontStyles()), {
    listStyleType,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
    lineHeight: theme.lineHeight,
    margin: 0,
    paddingLeft: withPadding ? theme.spacing.xl : 0,
    listStylePosition: "inside"
  })
}));

/* harmony default export */ var List_styles = (List_styles_useStyles);
//# sourceMappingURL=List.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/List.js







var List_defProp = Object.defineProperty;
var List_getOwnPropSymbols = Object.getOwnPropertySymbols;
var List_hasOwnProp = Object.prototype.hasOwnProperty;
var List_propIsEnum = Object.prototype.propertyIsEnumerable;
var List_defNormalProp = (obj, key, value) => key in obj ? List_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var List_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (List_hasOwnProp.call(b, prop))
      List_defNormalProp(a, prop, b[prop]);
  if (List_getOwnPropSymbols)
    for (var prop of List_getOwnPropSymbols(b)) {
      if (List_propIsEnum.call(b, prop))
        List_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var List_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (List_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && List_getOwnPropSymbols)
    for (var prop of List_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && List_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const List_defaultProps = {
  type: "unordered",
  size: "md",
  spacing: 0
};
const List = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("List", List_defaultProps, props), {
    children,
    type,
    size,
    listStyleType,
    withPadding,
    center,
    spacing,
    icon,
    className,
    styles,
    classNames,
    unstyled
  } = _a, others = List_objRest(_a, [
    "children",
    "type",
    "size",
    "listStyleType",
    "withPadding",
    "center",
    "spacing",
    "icon",
    "className",
    "styles",
    "classNames",
    "unstyled"
  ]);
  const { classes, cx } = List_styles({ withPadding, size, listStyleType, center, spacing }, { classNames, styles, name: "List", unstyled });
  return /* @__PURE__ */ react.createElement(ListProvider, {
    value: {
      spacing,
      center,
      icon,
      listStyleType,
      size,
      withPadding,
      classNames,
      styles,
      unstyled
    }
  }, /* @__PURE__ */ react.createElement(Box/* Box */.x, List_spreadValues({
    component: type === "unordered" ? "ul" : "ol",
    className: cx(classes.root, className),
    ref
  }, others), children));
});
List.Item = ListItem;
List.displayName = "@mantine/core/List";


//# sourceMappingURL=List.js.map


/***/ }),

/***/ 22871:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(59123);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56817);

/* harmony default export */ __webpack_exports__["Z"] = ((0,_mantine_styles__WEBPACK_IMPORTED_MODULE_0__/* .createStyles */ .k)(function(theme) {
    return {
        paper: {
            margin: "0 auto",
            textAlign: "justify",
            fontSize: 12,
            maxWidth: 500,
            padding: 20,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3],
            boxShadow: theme.shadows.sm,
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7]
        },
        h1: {
            textAlign: "center",
            letterSpacing: 0.6
        },
        h2: {
            textAlign: "center",
            letterSpacing: 0.6,
            color: theme.colors.orange[5]
        },
        staticListMain: {
            fontSize: 12,
            lineHeight: 1.8,
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[8],
            "li": {
                borderBottom: 1,
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
                borderStyle: "dashed",
                borderColor: theme.colors.gray[6]
            },
            "li:last-child": {
                borderBottom: 0
            }
        },
        staticListNested: {
            fontSize: 12,
            lineHeight: 1.8,
            color: theme.colorScheme === "dark" ? theme.colors.gray[3] : theme.colors.gray[7],
            "li": {
                borderBottom: 1,
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
                borderStyle: "dashed",
                borderColor: theme.colors.orange[3]
            },
            "li:last-child": {
                borderBottom: 0
            }
        }
    };
}));


/***/ }),

/***/ 59123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ terms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/core/components/common/AppHead.tsx
var AppHead = __webpack_require__(46055);
// EXTERNAL MODULE: ./src/core/layouts/AppLayout.tsx + 27 modules
var AppLayout = __webpack_require__(74797);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/List/List.js + 4 modules
var List = __webpack_require__(8949);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./src/features/static-pages/Static.styles.ts
var Static_styles = __webpack_require__(20836);
;// CONCATENATED MODULE: ./src/features/static-pages/TermsLanding.tsx




var TermsLanding = function() {
    var classes = (0,Static_styles/* default */.Z)().classes;
    var listTermsData = [
        {
            label: "Reservation is confirmed only after complete settlement of rental amount, security deposit, taxes and confirmation email sent by DXB Stay (Vacation Rentals Portal) to the guest."
        },
        {
            label: "The guest has read, agrees to, and understands that the house policies are an integral part of this agreement."
        },
        {
            label: "The guest agrees to rent the property for the period mentioned on the reservation form and is granted limited permission to occupy the property for temporary accommodation purposes and usage only. The reservation terms and house policies are in no way a residential tenancy agreement and does not fall under the Dubai residential tenancy legislation(s)."
        }, 
    ];
    var listTermsItems = listTermsData.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
            pt: 10,
            pb: 10,
            pr: 16,
            children: item.label
        }, item.label);
    });
    var listTermsNestedOneData = [
        {
            label: "Sublease of the property or transfer of the reservation to any other party is strictly prohibited."
        },
        {
            label: "Guest must carry and be able to present upon request a valid original passport and the original debit/credit card used for the reservation."
        },
        {
            label: "Any minors should be accompanied by an adult at the time of check-in."
        },
        {
            label: "The rental amount is inclusive of all utility bills and housekeeping services twice a week. This does not include use of on demand video services, any upgrades to the existing internet or cable TV package, paid local or international calls from the landline of the property and additional services or items requested by the guest, any such charges will be paid separately by the guest."
        },
        {
            label: "The maximum capacity of guests allowed in the property should be strictly observed and followed."
        },
        {
            label: "Additional visitors and guests are not allowed for overnight stays."
        },
        {
            label: "Guest agrees to provide housekeeping and service staff access to the property."
        },
        {
            label: "Guest must inform DXB Stay (Vacation Rentals Portal) of any damage to the property or its contents."
        },
        {
            label: "Guest agrees that DXB Stay (Vacation Rentals Portal) and the operator are not liable under any circumstances for loss, theft, damage to personal belongings, injury, illness, sickness or death to the guests or visitors."
        },
        {
            label: "Guest agrees that in case of non-compliance of the reservation terms and house policies the operator has the right to evict the guest from the property and in any such case the guest will forfeit the total rental amount and security deposit."
        },
        {
            label: "All rates and charges are calculated and paid in AED or its equivalent."
        },
        {
            label: "All rental payments made towards the reservation of the property are non-refundable in case of cancellation, no show, or early departure."
        },
        {
            label: "If the reservation is cancelled by the operator for any reason, then the entire amount will be refunded to the guest with no other liabilities."
        },
        {
            label: "In case of overstaying guest/s a penalty of AED 1,000/- per day in addition to the daily rental rate will be applied and all possible measures will be taken to evict the guest, including blocking access to the property, disconnection of utilities and involvement of the authorities."
        },
        {
            label: "In case the guest wants to extend the stay this should be agreed upon and paid for in advance before the check-out date and is subject to availability."
        },
        {
            label: "Security deposits are refundable subject to the below terms and conditions."
        }, 
    ];
    var listTermsNestedOneItems = listTermsNestedOneData.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
            pt: 10,
            pb: 10,
            pr: 16,
            children: item.label
        }, item.label);
    });
    var listTermsTwoData = [
        {
            label: "Guest agrees to pay the required security deposit at the time of reservation, refunds will be processed within 7 to 14 nights after check-out. The security deposit is subject to deductions in the event of:"
        }, 
    ];
    var listTermsTwoItems = listTermsTwoData.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
            pt: 10,
            pb: 10,
            pr: 16,
            children: item.label
        }, item.label);
    });
    var listTermsNestedTwoData = [
        {
            label: "Any damages to the property or common areas."
        },
        {
            label: "Missing or damaged items in the property."
        },
        {
            label: "Loss or damage of access cards provided to the guest."
        },
        {
            label: "Non-compliance of house policies."
        },
        {
            label: "Penalties imposed by community management and/or government authorities for non-compliance of any rules or regulations by the guests or their visitors."
        },
        {
            label: "For use of on demand video services, upgrades to the existing internet or cable TV package, paid local or international calls from the landline of the property and any unsettled bills for extra services or items requested by the guests or visitors."
        }, 
    ];
    var listTermsNestedTwoItems = listTermsNestedTwoData.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
            pt: 10,
            pb: 10,
            pr: 16,
            children: item.label
        }, item.label);
    });
    var listInvolvedData = [
        {
            label: "DXB Stay (Vacation Rentals Portal): DXB Stay (Vacation Rentals Portal) only provides a platform through which operators can advertise, market, sell promote and/or offer their products and services for order, purchase, reservation, rent or hire, and through which relevant visitors of the platform can discover, search, compare, and make an order, reservation, purchase, or payment."
        },
        {
            label: "By using or utilizing the platform, you enter a direct (legally binding) contractual relationship with the operator in which you make a reservation or purchase a product or service."
        },
        {
            label: "From the point at which you make your reservation, we act solely as an intermediary between you and the operator. We transmit the relevant details of your reservation to the relevant operator and send you a confirmation email for and on behalf of the operator. DXB Stay (Vacation Rentals Portal) does not (re)sell, rent out, offer any (travel) product or service."
        },
        {
            label: "Operator: The operator is the provider of the product and/or services and has the relevant permits in place to conduct the activities."
        },
        {
            label: "Guests: Any individual(s) or organization using the platform for making purchases and/or reservations."
        }, 
    ];
    var listInvolvedItems = listInvolvedData.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
            pt: 10,
            pb: 10,
            pr: 16,
            children: item.label
        }, item.label);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
            className: classes.paper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    className: classes.h1,
                    order: 1,
                    children: "Terms & Conditions"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                    pt: 10,
                    className: classes.staticListMain,
                    children: listTermsItems
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                    className: classes.staticListNested,
                    listStyleType: "circle",
                    children: listTermsNestedOneItems
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                    pt: 10,
                    className: classes.staticListMain,
                    children: listTermsTwoItems
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                    className: classes.staticListNested,
                    listStyleType: "circle",
                    children: listTermsNestedTwoItems
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    color: "red",
                    pt: 30,
                    pb: 30,
                    size: "sm",
                    children: "*** In case the security deposit is not sufficient to cover any of the above the guest agrees to be fully liable and pay any difference amount immediately to complete the shortfall."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    className: classes.h1,
                    order: 1,
                    children: "Involved Parties"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                    pt: 10,
                    pb: 20,
                    className: classes.staticListMain,
                    children: listInvolvedItems
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/terms.tsx




var TermsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsLanding, {});
};
// @ts-expect-error
TermsPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHead/* default */.Z, {
                title: "Terms & Conditions",
                description: "If you would like to know more about the use of the DXB Stay website and the terms and conditions of using and/or booking and/or staying at the properties we offer please read through this page."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
                requireAuth: false,
                children: page
            })
        ]
    });
};
/* harmony default export */ var terms = (TermsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [584,662,930,207,774,888,377], function() { return __webpack_exec__(22871); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);